import React, { useEffect, useRef } from "react";
import Epitome from "./Epitome";
import SharedLayout from "./SharedLayout";
import "../styles/PageWrappers.css";
import scrollToTop from "../utils/scrollToTop";

const EpitomeView = ({ user, onLoginClick }) => {
  const mountedRef = useRef(false);

  // Mobile-specific detection
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  // Check for URL parameters that indicate this is a fresh window on mobile
  const location = window.location;
  const params = new URLSearchParams(location.search);
  const isMobileNewWindow =
    params.get("mobile") === "true" && params.get("new") === "true";

  // Force scroll to top when component mounts, with multiple methods for redundancy
  useEffect(() => {
    // Even more aggressive for mobile new window
    if (isMobileNewWindow) {
      console.log("Mobile new window detected - using aggressive scroll");

      // Immediate scroll attempts
      window.scrollTo(0, 0);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;

      // Prevent any scroll restoration
      if ("scrollRestoration" in window.history) {
        window.history.scrollRestoration = "manual";
      }

      // Force scroll multiple times with increasing delays
      const scrollIntervals = [
        10, 50, 100, 300, 500, 800, 1000, 1500, 2000, 3000,
      ];

      scrollIntervals.forEach((delay) => {
        setTimeout(() => {
          window.scrollTo(0, 0);
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
        }, delay);
      });

      // Add special class for mobile new window
      document.documentElement.classList.add("force-top-scroll");
      document.body.classList.add("force-top-scroll");

      return () => {
        document.documentElement.classList.remove("force-top-scroll");
        document.body.classList.remove("force-top-scroll");
      };
    }

    // Initial scroll attempts
    scrollToTop();
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    // More aggressive approach for mobile
    if (isMobile) {
      // Force scroll multiple times with increasing delays
      const scrollIntervals = [10, 50, 100, 300, 500, 1000, 2000];

      scrollIntervals.forEach((delay) => {
        setTimeout(() => {
          window.scrollTo(0, 0);
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
        }, delay);
      });

      // Try to prevent any native scroll restoration
      if ("scrollRestoration" in window.history) {
        window.history.scrollRestoration = "manual";
      }
    } else {
      // For desktop, fewer attempts are needed
      const scrollTimeout = setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);

      const secondScrollTimeout = setTimeout(() => {
        window.scrollTo(0, 0);
        mountedRef.current = true;
      }, 500);

      return () => {
        clearTimeout(scrollTimeout);
        clearTimeout(secondScrollTimeout);
      };
    }
  }, [isMobile, isMobileNewWindow]);

  // Add classes to body for proper styling
  useEffect(() => {
    // Add both general and mobile-specific classes
    document.body.classList.add("epitome-page");
    if (isMobile) {
      document.body.classList.add("mobile-epitome");
    }

    return () => {
      document.body.classList.remove("epitome-page");
      document.body.classList.remove("mobile-epitome");
    };
  }, [isMobile]);

  return (
    <SharedLayout user={user} onLoginClick={onLoginClick}>
      <div
        className="epitome-wrapper"
        style={{
          maxWidth: "1000px",
          margin: "0 auto",
          padding: "40px 20px 20px",
          minHeight: "100vh",
        }}
      >
        <div
          style={{
            textAlign: "center",
            marginBottom: "2rem",
            width: "100%",
          }}
        >
          <h1
            className="epitome-title"
            style={{
              margin: "0 auto",
              fontFamily: '"Times New Roman", Times, serif',
              fontStyle: "italic",
              color: "#3498db",
              fontSize: "2.5rem",
              fontWeight: "700",
              letterSpacing: "1px",
              textTransform: "uppercase",
              padding: "0.5rem 0",
              textAlign: "center",
              display: "block",
            }}
          >
            EPITOME
          </h1>
          <div
            className="epitome-title-underline"
            style={{
              width: "80px",
              height: "3px",
              background: "#3498db",
              margin: "0 auto",
              marginTop: "5px",
            }}
          ></div>
        </div>

        <Epitome />
      </div>
    </SharedLayout>
  );
};

export default EpitomeView;
